
// src/web/components/google-signin-provider.jsx

import React from 'react'
import {
  Button,
} from 'react-toolbox/lib/button'
import config from '../../config'
import Tooltip from 'react-toolbox/lib/tooltip';
import { track } from '../../helpers/analytics';

const MAX_TIMEOUT = 200
const GOOGLE_GSI_CLIENT = "https://accounts.google.com/gsi/client"
const GOOGLE_API_CLIENT = "https://apis.google.com/js/api.js"
const GOOGLE_API_TOKEN = "Google_API_Token"
let GSIClient
let GSIOnSuccess
let GSI_retry = 0
let GAPI_retry = 0
let GSCode
let GSC_retry = 0
let GSCOnSuccess

class GoogleSigninProvider extends React.PureComponent {
	onGSIload = ()=> {
		if (typeof google === 'undefined' || typeof google.accounts === 'undefined' || typeof google.accounts.oauth2 == 'undefined') {
			GSI_retry += 1
			if (GSI_retry <= 3)
				setTimeout(this.onGSIload, MAX_TIMEOUT)
			return
		}
		GSIClient = google.accounts.oauth2.initTokenClient({
			client_id: config.integrationKeys.google.clientId,
			scope: config.integrationKeys.google.scope.join(' '),
			prompt: '',
			callback: (response) => {
				if (response && response.access_token) {
					response.expires_at = (new Date).valueOf() + response.expires_in * 1000
					localStorage.setItem(GOOGLE_API_TOKEN, JSON.stringify(response))
					gapi.client.setToken(response)
					GSIOnSuccess && GSIOnSuccess()
					GSIOnSuccess = undefined
				}
			},
		});
	}

	onGAPILoad = ()=> {
		if (typeof gapi === 'undefined') {
			GAPI_retry += 1
			if (GAPI_retry <= 3)
				setTimeout(this.onGAPILoad, MAX_TIMEOUT)
			return
		}
		gapi.load('client', ()=> {
			const token = JSON.parse(localStorage.getItem(GOOGLE_API_TOKEN) || '{}')
			if (token && token.access_token && token.expires_at && token.expires_at > (new Date).valueOf()) {
				gapi.client.setToken(token)
			}
			gapi.client.setApiKey(config.integrationKeys.apiKey)
   		gapi.client.load('drive', 'v3', ()=> undefined)
   		gapi.client.load('calendar', 'v3', ()=> undefined)
		})
	}

	onGSCode = ()=> {
		if (typeof google === 'undefined' || typeof google.accounts === 'undefined' || typeof google.accounts.oauth2 == 'undefined') {
			GSC_retry += 1
			if (GSC_retry <= 3)
				setTimeout(this.onGSCode, MAX_TIMEOUT)
			return
		}
		GSCode = google.accounts.oauth2.initCodeClient({
			client_id: config.integrationKeys.google.clientId,
			scope: config.integrationKeys.google.scope.join(' '),
			response_type: 'code',
			callback: (response) => {
				if (response && response.code) {
					localStorage.setItem("Google_Auth_Code", response.code)
					GSCOnSuccess && GSCOnSuccess()
					GSCOnSuccess = undefined
				}
			},
		});
	}

	componentDidMount() {
		const firstScript = document.getElementsByTagName('script')[0]
		const gsiScript = document.createElement('script')
		const gapiScript = document.createElement('script')
		const gscScript = document.createElement('script')

		gsiScript.src = GOOGLE_GSI_CLIENT
		gsiScript.onload = this.onGSIload
		gapiScript.src = GOOGLE_API_CLIENT
		gapiScript.onload = this.onGAPILoad
		gscScript.src = GOOGLE_GSI_CLIENT
		gscScript.onload = this.onGSCode

		firstScript.parentNode.insertBefore(gsiScript, firstScript)
		firstScript.parentNode.insertBefore(gapiScript, firstScript)
		firstScript.parentNode.insertBefore(gscScript, firstScript)
	}

	render() {
	  const {
	    children,
	  } = this.props

	  return (
	    <div>
	      {children}
	    </div>
	  )
	}
}

const googleLoginButtonStyle = {
	display: 'inline-block',
	background: '#303fa8',
	color: '#fff',
	width: '100%',
	fontWeight: 'bold',
};

const googleLoginButtonStyleSecond = {
	display: 'block',
	background: 'rgb(63 81 181)',
	color: '#fff',
	width: '50%',
};

export class GoogleLogin extends React.PureComponent {
	componentDidMount() {
		const token = JSON.parse(localStorage.getItem(GOOGLE_API_TOKEN) || '{}')
		if (token && token.access_token && token.expires_at && token.expires_at > (new Date).valueOf())
			this.onSuccess()
		const auth_code = localStorage.getItem("Google_Auth_Code")
		if (auth_code) this.onCodeSuccess()
	}

	onSuccess = ()=> {
		this.props.onSuccess && this.props.onSuccess()
	}

	onCodeSuccess = ()=> {
		this.props.onCodeSuccess && this.props.onCodeSuccess()
	}


	onClick = (type)=> {
    	track('onGoogleSigninClick')
		if (type == 'refresh_token') {
			GSCOnSuccess = this.onCodeSuccess
			GSCode && GSCode.requestCode()
		} else {
			GSIOnSuccess = this.onSuccess
			GSIClient && GSIClient.requestAccessToken()
		}
	}

	render() {
		const token = JSON.parse(localStorage.getItem(GOOGLE_API_TOKEN) || '{}')
		if ((token && token.access_token && token.expires_at && token.expires_at > (new Date).valueOf()) && this.props.type != 'refresh_token')
			return null
		else
			return (<Button primary style={this.props.type && (this.props.type=='google_drive' || this.props.type=='refresh_token') ? googleLoginButtonStyleSecond : googleLoginButtonStyle} onClick={()=> this.onClick(this.props.type)} label={this.props.label} />)
	}

	static signOut() {
		localStorage.removeItem(GOOGLE_API_TOKEN)
		localStorage.removeItem("Google_Auth_Code")
		google.accounts.oauth2.revoke()
	}
}

export default GoogleSigninProvider



// WEBPACK FOOTER //
// ./src/web/components/google-signin-provider.jsx